/* eslint-disable */
/**
 * Galéria aloldal (single gallery-cpt): tab és lapozás AJAX-szal, oldal újratöltés nélkül.
 */
(function ($) {
  "use strict";

  function loadGalleryContent($section, tab, paged, callback) {
    var galleryId = $section.data("gallery-id");
    var ajaxUrl =
      $section.data("ajax-url") ||
      (typeof localize !== "undefined" ? localize.ajaxurl : "");
    if (!galleryId || !ajaxUrl) {
      if (callback) callback(false);
      return;
    }
    $section.addClass("is-loading");
    $.post(ajaxUrl, {
      action: "cordia_gallery_single_content",
      gallery_id: galleryId,
      tab: tab,
      paged: paged,
    })
      .done(function (res) {
        if (res.success && res.data && res.data.html !== undefined) {
          var $content = $section.find(".js-gallery-single-content");
          if ($content.length) {
            $content.html(res.data.html);
          }
          if (callback) callback(true);
        } else {
          if (callback) callback(false);
        }
      })
      .fail(function () {
        if (callback) callback(false);
      })
      .always(function () {
        $section.removeClass("is-loading");
      });
  }

  function updateUrl(tab, paged) {
    var $section = $(".section-gallery-single");
    var base =
      $section.data("base-url") ||
      window.location.pathname + window.location.search;
    var url = base.split("?")[0];
    var params = [];
    if (tab) params.push("tab=" + encodeURIComponent(tab));
    if (paged && paged > 1) params.push("paged=" + paged);
    if (params.length) url += "?" + params.join("&");
    if (window.history && window.history.replaceState) {
      window.history.replaceState({ tab: tab, paged: paged }, "", url);
    }
  }

  function setActiveTab($section, tab) {
    $section
      .find(".js-gallery-single-tab")
      .removeClass("active")
      .filter('[data-tab="' + tab + '"]')
      .addClass("active");
    var $select = $section.find(".js-gallery-single-select");
    if ($select.length && $select.val() !== tab) {
      $select.val(tab);
      if ($select[0].sumo) {
        try {
          $select[0].sumo.setText(tab);
        } catch (e) {}
      }
    }
    $section.find(".section-gallery-single__panel").attr("data-tab", tab);
  }

  function initGallerySingle() {
    var $section = $(".section-gallery-single");
    if (!$section.length) return;

    var ajaxUrl =
      $section.data("ajax-url") ||
      (typeof localize !== "undefined" ? localize.ajaxurl : "");

    // Tab link (desktop)
    $section.on("click", ".js-gallery-single-tab", function (e) {
      e.preventDefault();
      var tab = $(this).data("tab");
      if (!tab) return;
      loadGalleryContent($section, tab, 1, function () {
        setActiveTab($section, tab);
        updateUrl(tab, 1);
      });
    });

    // Pagination link (prev/num/next with class js-gallery-single-pagination)
    $section.on("click", ".js-gallery-single-pagination", function (e) {
      e.preventDefault();
      var $link = $(this);
      var tab = $link.data("tab");
      var paged = parseInt($link.data("paged"), 10) || 1;
      if (!tab) return;
      loadGalleryContent($section, tab, paged, function () {
        setActiveTab($section, tab);
        updateUrl(tab, paged);
      });
    });

    // Select (mobile)
    var $select = $section.find(".js-gallery-single-select");
    if ($select.length && typeof $().SumoSelect === "function") {
      $select.SumoSelect({
        placeholder:
          typeof localize !== "undefined" &&
          localize.translations &&
          localize.translations.optionSelectText
            ? localize.translations.optionSelectText
            : "Válasszon",
        csvDispCount: 2,
        search: false,
      });
    }
    $select.on("change", function () {
      var tab = $(this).val();
      if (!tab) return;
      loadGalleryContent($section, tab, 1, function () {
        setActiveTab($section, tab);
        updateUrl(tab, 1);
      });
    });
  }

  $(function () {
    initGallerySingle();
    console.log("helo");
  });
})(jQuery);
